export default __webpack_public_path__ + "static/media/Pilgrim's Leggings of the Bloody Stone.458320e0.jpg";